import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Loader2 } from 'lucide-react';
import apiClient from '@/utils/api';

export const CV_TEMPLATES = ['classic', 'modern', 'minimal', 'photo'];

const Thumb = ({ template, lang, refreshKey }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    let cancelled = false;
    apiClient.get('/cv/me/preview.jpg', { params: { lang, template, t: refreshKey }, responseType: 'blob', timeout: 60000 })
      .then((r) => { if (!cancelled) { url = URL.createObjectURL(r.data); setSrc(url); } })
      .catch(() => {});
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [template, lang, refreshKey]);
  return src
    ? <img src={src} alt={template} className="w-full h-full object-cover object-top" />
    : <span className="w-full h-full flex items-center justify-center text-slate-400"><Loader2 className="h-5 w-5 animate-spin" /></span>;
};

// Lets the candidate pick one of 3 visual templates; the choice is saved in the CV document (cv.template)
export const CVTemplatePicker = ({ value = 'classic', onChange, lang = 'pt', refreshKey }) => {
  const { t } = useTranslation();
  return (
    <div data-testid="cv-template-picker">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">{t('cvBuilder.review.templateTitle')}</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {CV_TEMPLATES.map((tpl) => {
          const active = value === tpl;
          return (
            <button
              key={tpl}
              type="button"
              onClick={() => onChange(tpl)}
              aria-pressed={active}
              className={`group text-left rounded-xl border-2 p-2 transition-colors ${active ? 'border-blue-600 bg-blue-50/50' : 'border-slate-200 hover:border-slate-400 bg-white'}`}
              data-testid={`cv-template-${tpl}`}
            >
              <div className="relative aspect-[210/297] overflow-hidden rounded-md bg-white ring-1 ring-slate-200">
                <Thumb template={tpl} lang={lang} refreshKey={refreshKey} />
                {active && <span className="absolute top-1.5 right-1.5 h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center" data-testid={`cv-template-${tpl}-selected`}><Check className="h-3.5 w-3.5" /></span>}
              </div>
              <p className={`mt-2 text-sm font-semibold ${active ? 'text-blue-800' : 'text-slate-800'}`}>{t(`cvBuilder.review.templates.${tpl}.name`)}</p>
              <p className="text-[11px] text-slate-500 leading-snug">{t(`cvBuilder.review.templates.${tpl}.desc`)}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};
